import { isNumberOrString } from "@draftkings/sportsbook-common-utils";
export const pointsFormatBuilder = (localizationApi) => getPointsFormatted.bind(undefined, localizationApi);
export function getPointsFormatted(localizationApi, selection) {
    const pointsFormatted = formatPoints(localizationApi, selection.points);
    return !isOverUnderSelection(selection.outcomeType) && selection.points && selection.points > 0
        ? `+${pointsFormatted}`
        : pointsFormatted;
}
function formatPoints(localizationApi, amount) {
    const options = { maximumFractionDigits: 2, useGrouping: false };
    const formatter = localizationApi.getPointsFormat(options);
    return isNumberOrString(amount)
        ? formatter.format(amount)
        : "";
}
function isOverUnderSelection(outcomeType) {
    return outcomeType === "Over"
        || outcomeType === "Under"
        || outcomeType === "Exactly";
}
//# sourceMappingURL=pointsFormatBuilder.js.map